import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import H5Cropper from 'vue-cropper-h5';
import { uploadImg, userInfoModify } from '@/api/mg';
export default {
  components: {
    H5Cropper: H5Cropper
  },
  data: function data() {
    return {
      genderArr: ['male', 'female'],
      isShowLoading: false,
      state: 'uploading...',
      isActive: true,
      nickname: '',
      signature: '',
      gender: '',
      genderId: '',
      birthday: '',
      option: {},
      img: '',
      imgId: '',
      showGender: false,
      showBirth: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      avatar: ''
    };
  },
  created: function created() {
    this.userInfo = JSON.parse(this.$route.query.userInfo);
    this.img = this.userInfo.avatarUrl;
    this.signature = this.userInfo.signature;
    this.nickname = this.userInfo.nickname;
    this.genderId = this.userInfo.gender;
    if (this.genderId === 1) {
      this.gender = 'male';
    } else if (this.genderId === 1) {
      this.gender = 'female';
    } else {
      this.gender = '';
    }
    this.birthday = this.userInfo.birthday;
  },
  methods: {
    dateFormat: function dateFormat(fmt, date) {
      var ret;
      var opt = {
        'Y+': date.getFullYear().toString(),
        // 年
        'm+': (date.getMonth() + 1).toString(),
        // 月
        'd+': date.getDate().toString(),
        // 日
        'H+': date.getHours().toString(),
        // 时
        'M+': date.getMinutes().toString(),
        // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };

      for (var k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
        }
      }
      return fmt;
    },
    showBirthPop: function showBirthPop() {
      this.showBirth = true;
    },
    onConfirm: function onConfirm(value, index) {
      this.gender = value;
      if (this.gender === 'male') {
        this.genderId = 1;
      } else {
        this.genderId = 2;
      }
      this.showGender = false;
    },
    onChange: function onChange(picker, value, index) {},
    onCancel: function onCancel() {
      this.showGender = false;
    },
    onConfirm1: function onConfirm1(value, index) {
      this.birthday = this.dateFormat('YYYY-mm-dd', value);
      this.showBirth = false;
    },
    onChange1: function onChange1(picker, value, index) {},
    onCancel1: function onCancel1() {
      this.showBirth = false;
    },
    showGenderPop: function showGenderPop() {
      this.showGender = true;
    },
    getFile: function getFile(file) {
      var _this = this;
      this.isShowLoading = true;
      console.log(file, 'file');
      if (file instanceof Array) {
        // 判断是否是数组
        file.map(function (item) {
          var formData = new FormData();
          formData.append('file', item.file);
          formData.append('type', 1);
          item.status = 'uploading';
          item.message = 'uploading...';
          uploadImg(formData).then(function (res) {
            if (res.Code === 0) {
              item.id = res.Data.id;
              item.status = 'done';
              item.message = 'success';
            } else {
              item.status = 'failed';
              item.message = 'failed';
            }
          }).catch(function () {
            item.status = 'failed';
            item.message = 'failed';
          });
        });
      } else {
        var formData = new FormData();
        formData.append('file', file);
        formData.append('type', 1);
        file.status = 'uploading';
        file.message = 'uploading...';
        uploadImg(formData).then(function (res) {
          if (res.Code === 0) {
            _this.avatar = res.Data.thumbUrl;
            _this.state = 'success';
            var timer = setTimeout(function () {
              _this.isShowLoading = false;
              _this.state = 'uploading...';
              clearTimeout(timer);
            }, 1000);
          } else {
            _this.state = 'failed';
            _this.img = _this.userInfo.avatarUrl;
            var _timer = setTimeout(function () {
              _this.isShowLoading = false;
              _this.state = 'uploading...';
              clearTimeout(_timer);
            }, 1000);
          }
        }).catch(function () {
          _this.state = 'failed';
          _this.img = _this.userInfo.avatarUrl;
          var timer = setTimeout(function () {
            _this.isShowLoading = false;
            _this.state = 'uploading...';
            clearTimeout(timer);
          }, 1000);
        });
      }
    },
    getblobData: function getblobData() {},
    toSubmit: function toSubmit() {
      var _this2 = this;
      if (this.avatar || this.nickname || this.genderId || this.birthday || this.signature) {
        var params = {
          avatar: this.avatar,
          nickname: this.nickname,
          gender: this.genderId,
          birthday: this.birthday,
          signature: this.signature
        };
        console.log(params, 'params');
        userInfoModify(params).then(function (res) {
          if (res.Code === 0) {
            _this2.$router.back();
          } else {
            _this2.$toast(res.Message);
          }
        });
      } else {
        this.$toast('Incomplete information');
      }
    },
    input: function input() {},
    getbase64Data: function getbase64Data(data) {
      this.img = data;
    },
    back: function back() {
      this.$router.back();
    },
    toMessage: function toMessage() {
      this.$router.push({
        path: '/message'
      });
    },
    toDetail: function toDetail(name) {
      this.$router.push({
        path: '/me/detail',
        query: {
          str: name
        }
      });
    }
  }
};